import {FINISH_TRANSITION, IGNORED_TRANSITION, START_TRANSITION} from './routerActions'

const initialState = {
  transitioning: false,
  last: {
    currentName: null,
    params: {} as any,
    prevParams: {} as any,
  },
}

export const getTransitionValuesFromAction = (action) => {
  const currentName = action.transition.$to().name
  let params = action.transition.params('to')
  let prevParams = action.transition.params('from')
  // Override the original ui-router/redux behavior here. Originally the entire transition object was being stored,
  // which contained circular dependencies and a massive prototypical tree. This goes against redux rule of
  // only storing serializable objects, and it was even crashing devtools. We only take and store here what's needed, and can extend it.
  params = JSON.parse(JSON.stringify(params))
  prevParams = JSON.parse(JSON.stringify(prevParams))

  return {currentName, prevParams, params}
}

const routerReducer = (state = initialState, action) => {
  switch (action.type) {
  case START_TRANSITION: {
    return {
      transitioning: true,
      last: getTransitionValuesFromAction(action),
    }
  }
  case FINISH_TRANSITION: {
    return {
      transitioning: false,
      last: getTransitionValuesFromAction(action),
    }
  }
  case IGNORED_TRANSITION: {
    return {
      ...state,
      transitioning: false,
    }
  }
  default: {
    return state
  }
  }
}

export default routerReducer
